import { useState } from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { Flex, Tag } from "antd"
import { DSIcon } from "ui/Icon/DSIcon"
import styles from "../../index.module.css"

const AnswerAccordion = ({ item }) => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(true)
  return (
    <div className={styles.accordionItem}>
      <button type="button" className={styles.accordionHeader} onClick={() => setIsOpen((prev) => !prev)}>
        <Flex align="center" gap={8}>
          <DSIcon name="file" width={16} height={16} />
          <span className={styles.accordionTitle}>{item.topic}</span>
          {item.count > 0 && <Tag className={styles.answerCountTag}>{t("booking.reservation_detail.answers_count", { count: item.count })}</Tag>}
        </Flex>
        <span className={styles.accordionChevron}>{isOpen ? "∧" : "∨"}</span>
      </button>
      {isOpen && (
        <Flex vertical gap={12} className={styles.accordionBody}>
          {item.questions.map((qa) => (
            <Flex vertical gap={4} key={qa.q}>
              <p className={styles.question}>{qa.q}</p>
              <p className={styles.answer}>{qa.a}</p>
            </Flex>
          ))}
        </Flex>
      )}
    </div>
  )
}

AnswerAccordion.propTypes = {
  item: PropTypes.shape({
    topic: PropTypes.string.isRequired,
    count: PropTypes.number,
    questions: PropTypes.arrayOf(PropTypes.shape({ q: PropTypes.string, a: PropTypes.string })).isRequired
  }).isRequired
}

export default AnswerAccordion
